export * from '../src/composites/wui-tag/index.js';
//# sourceMappingURL=wui-tag.js.map